import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// styles
import { TypographyStyled } from './styles';

export default () => (
  <InformationalModule
    // configs
    sectionId='podcast-fr-connect'
    themeType='lightTheme'
    backgroundVariant='lightC'
    // content
    headingText={<>Ready to feel better about <WidowBlock>your money&#63;</WidowBlock></>}
    introContent={(
      <>
        <Typography
          align='left'
          nextElement='typography'>
          No matter where you&#39;re starting from, your Northwestern Mutual advisor will show you a better way to money<sup>&#174;</sup> so you can have a life better than you ever imagined.
        </Typography>
        <TypographyStyled
          align='left'
          nextElement='button'>
          <strong>It&#39;s easy to get started&#8212;no commitment, just a better conversation.</strong>
        </TypographyStyled>
        <Link
          id='podcast-fr-connect-fafa-link'
          variant='buttonLinkPrimary'
          ariaLabel='Talk to a financial advisor'
          linkUrl='/find-a-financial-advisor/'>
          Let&#39;s talk
        </Link>
      </>
    )}
  />
);
